import { render, staticRenderFns } from "./AnnouncementViewModal.vue?vue&type=template&id=502fbcb4"
import script from "./AnnouncementViewModal.vue?vue&type=script&lang=js"
export * from "./AnnouncementViewModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports